import React from 'react';
import CareCertified from 'assets/icons/center-certified.svg';
import { Text, Colors } from 'library';

export default function CenterCertifiedBanner() {
    return (
        <div
            style={{
                backgroundColor: Colors.mediumTurq,
                borderRadius: 30,
                padding: 8,
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'center',
                marginBottom: 8,
            }}
        >
            <CareCertified style={{ width: 32, height: 32, marginRight: 8 }} />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Text variant="body2" bold>
                    Tandem Center Certified
                </Text>
                <Text variant="caption">
                    Est. start date <b>ASAP</b>
                </Text>
            </div>
        </div>
    );
}
